export const VK_OPENAPI_SRC = 'https://vk.ru/js/api/openapi.js'
